export const oldProfilePersonalId = "old-profilepersonal";
export const oldProfileLocalId = "old-profilelocal";
export const oldProfileBusinessId = "old-profilebusiness";
export const oldProfileBankId = "old-profilebank";
export const oldSocialCardId = "old-social-card";
export const oldTelegramBotInfoCardId = "old-telegram-bot-card";
export const oldProfilePersonalCtaId = "old-profilepersonal-cta";
export const oldProfilePersonalCancelId = "old-profilepersonal-cancel";
export const oldProfileLocalCtaId = "old-profilelocal-cta";
export const oldProfileLocalCancelId = "old-profilelocal-cancel";
export const oldProfileBusinessCtaId = "old-profilebusiness-cta";
export const oldProfileBusinessCancelId = "old-profilebusiness-cancel";
export const oldProfileBankCtaId = "old-profilebank-cta";
export const oldProfileBankCancelId = "old-profilebank-cancel";
export const oldProfileSocialCtaId = "old-profilesocial-cta";
export const oldProfileSocialCancelId = "old-profilesocial-cancel";
export const notificationCardId = "notification-card";
export const consultingCardId = "consulting-card";
export const blogCardId = "blog-card";
export const downloadLinuxAppId = "download-linux-app";
export const downloadMacOSAppId = "download-macos-app";
export const downloadWindowsAppId = "download-windows-app";
export const downloadIOSAppId = "download-ios-app";
export const downloadAndroidAppId = "download-android-app";
export const profileCompletionId = "profile-completion";
export const profileDropdownId = "profile-dropdown";
export const frequentSettingsId = "frequent-settings";
export const frequentProductListId = "frequent-product-list";
export const frequentServicesId = "frequent-services";
export const frequentTokenCreateId = "frequent-token-create";
export const personalPageLinkId = "personal-page-link";
export const personalPageCopyId = "personal-page-link-copy";
export const downloadPersonalPageQrId = "download-personal-page-qr";
export const balanceCardId = "balance-card";
export const updateBalanceId = "update-balance";
export const referralOverviewCardId = "referral-overview-card";
export const referralOverviewLinkId = "referral-overview-link";
export const referralMenuDropdownId = "referral-menu-drop-down";
export const oldUserProfileId = "old-userprofile";
export const oldUserProfileRejectId = "old-userprofile-rejected";
export const oldUserProfileSuccess = "old-userprofile-success";
export const changetonewD2 = "changetonew-d2";
